// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94f9f43a","952":"b479e477"}[chunkId] + ".chunk.js";
};